import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from "@/router";

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App),
  data() {
    return {
      windowHeight: window.innerHeight,
      txt: ''
    }
  },

  watch: {
    windowHeight(newHeight, oldHeight) {
      this.txt = `it changed to ${newHeight} from ${oldHeight}`;
    }
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
      //window.removeEventListener('scroll', this.onScroll);
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    onResize() {
      this.windowHeight = window.innerHeight
    }
  }
}).$mount('#app')